import { apiClient, API_PRX } from '@indipia/shared';

/**
 * 고객 상담문의(리드) API — 고객상담 요청접수관리 설계 §6.
 * 주의: 기존 `inquiries.ts`(사장님→플랫폼 1:1 문의, support 영역)와 다른 도메인이라
 * 파일·타입명을 분리한다(고객→사장님 상담문의).
 */

export type CustomerInquiryStatus = 'NEW' | 'CONTACTED' | 'SCHEDULED' | 'DONE';

export interface CustomerInquiryItem {
  inquiryId: number;
  inquiryStatus: CustomerInquiryStatus;
  customerName: string;
  customerPhone: string;
  sourceRefTitle: string | null;
  inquiryMessage: string | null;
  createdAt: string;
  converted: boolean;
}

export interface CustomerInquiryListParams {
  status?: CustomerInquiryStatus;
  keyword?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
}

export interface CustomerInquiryPagedList {
  content: CustomerInquiryItem[];
  page: number;
  size: number;
  totalElements: number;
}

export interface CustomerInquiryStats {
  newThisWeek: number;
  overdueNew: number;
  responseRate: number;
  avgResponseMinutes: number | null;
}

export async function fetchCustomerInquiries(
  params: CustomerInquiryListParams = {},
): Promise<CustomerInquiryPagedList> {
  const res = await apiClient.get(`${API_PRX.CUSTOMER}/inquiries`, { params });
  return res.data.data;
}

export async function fetchCustomerInquiryStats(): Promise<CustomerInquiryStats> {
  const res = await apiClient.get(`${API_PRX.CUSTOMER}/inquiries/stats`);
  return res.data.data;
}

export async function updateCustomerInquiryStatus(
  inquiryId: number,
  status: CustomerInquiryStatus,
): Promise<void> {
  await apiClient.patch(`${API_PRX.CUSTOMER}/inquiries/${inquiryId}/status`, { inquiryStatus: status });
}
